import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const slider1 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819452slider1.jpg";
const slider11 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819454slider11.jpg";
const slider12 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819455slider12.jpg";
const slider13 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819455slider13.jpg";
const slider14 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819455slider14.jpg";
const slider15 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819455slider15.jpg";
const slider16 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819455slider16.jpg";
const slider17 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819456slider17.jpg";
const slider18 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819456slider18.jpg";
const slider19 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819456slider19.jpg";
const slider20 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819451slider20.jpg";

const slider2 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819452slider2.jpg";
const slider3 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819452slider3.jpg";
const slider4 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819452slider4.jpg";
const slider5 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819453slider5.jpg";
const slider6 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819453slider6.jpg";
const slider7 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819453slider7.jpg";
const slider8 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819454slider8.jpg";
const slider9 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819454slider9.jpg";
const slider10 = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737819454slider10.jpg";

const Body = () => {
  return (
    <>
    <div className="container">
      <div className="row">
      <div class="col-12">
      <div class="sliderbox">
        {/* Carousel Section */}
        <div
          id="carouselExampleIndicators"
          className="carousel slide mb-4"
          data-bs-ride="carousel"
        >
          <div
            className="carousel-indicators sliderthumb overflow-auto"
            style={{
              whiteSpace: "nowrap",
              overflowX: "auto",
              scrollbarWidth: "none", // For Firefox
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.scrollBehavior = "smooth";
            }}
          >
            {/* Thumbnail Buttons */}
            {[
              slider1,
              slider11,
              slider12,
              slider13,
              slider14,
              slider15,
              slider16,
              slider17,
              slider18,
              slider19,
              slider20,
              slider2,
              slider3,
              slider4,
              slider5,
              slider6,
              slider7,
              slider8,
              slider9,
              slider10,
            ].map((slider, index) => (
              <button
                key={index}
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-label={`slider ${index + 1}`}
                style={{ width: "500px", height: "50px" }}
              >
                <img
                  src={slider}
                  alt={`Thumbnail ${index + 1}`}
                  className="d-block w-100"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </button>
            ))}
          </div>

          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                src={slider1}
                className="d-block w-100 rounded-image"
                alt="slider 1"
              />
            </div>
            {[
               
               slider11,
               slider12,
               slider13,
               slider14,
               slider15,
               slider16,
               slider17,
               slider18,
               slider19,
               slider20,
               slider2,
               slider3,
               slider4,
               slider5,
               slider6,
               slider7,
               slider8,
               slider9,
               slider10,
            ].map((slider, index) => (
              <div key={index} className="carousel-item">
                <img
                  src={slider}
                  className="d-block w-100 rounded-image"
                  alt={`slider ${index + 2}`}
                />
              </div>
            ))}
          </div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
        </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Body;
